import { StyleSheet } from "react-native";
import { theme } from "@lookiero/sty-psp-ui";

const style = () => {
  const { borderRadius4, colorBgBase, colorBgPrimaryLight, space1, space12, space16, space4, space6, colorTextMedium } =
    theme();

  return StyleSheet.create({
    detailLarge: {
      backgroundColor: colorBgBase,
      borderRadius: borderRadius4,
      paddingHorizontal: space6,
      paddingVertical: space6,
    },
    detailSmall: {
      backgroundColor: colorBgBase,
    },
    detailWrapperLarge: {
      marginTop: space12,
      paddingRight: space16,
    },
    expired: {
      marginBottom: space6,
    },
    fullWidthButton: {
      width: "100%",
    },
    info: {
      marginTop: space6,
    },
    infoBox: {
      marginBottom: space6,
    },
    largeBanner: {
      marginBottom: space6,
    },
    layout: {
      paddingBottom: space12,
    },
    resumeWrapper: {
      padding: space6,
    },
    resumeWrapperLarge: {
      backgroundColor: colorBgBase,
      borderRadius: borderRadius4,
      marginTop: space12,
    },
    returnButton: {
      marginTop: space6,
    },
    smallBannerWrapper: {
      paddingHorizontal: space6,
    },
    smallReturnButton: {
      marginHorizontal: space6,
      marginVertical: space6,
    },
    smallReturnInfo: {
      paddingHorizontal: space6,
    },
    subtitle: {
      color: colorTextMedium,
      marginBottom: space1,
    },
    totalTable: {
      marginTop: space4,
    },
    wrapper: {
      backgroundColor: colorBgPrimaryLight,
      flex: 1,
    },
  });
};

export { style };
